import React from 'react'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { LeadActionStep } from './LeadActionPanel'

const STEP_LABELS = [
  'Availability check (FREE)',
  'Practice Details',
  'Confirmation',
]

const STEP_MAP: Record<LeadActionStep, number | null> = {
  'add-availability-check': 0,
  'create-practice': 1,
  'set-password': 1,
  'setup-billing': 2,
  'looking-for-nurse': 2,
  'confirm-booking': 2,
  'availability-check-expired': null,
}

interface Props {
  currentStep: LeadActionStep
}

const LeadActionPanelStepper: React.FC<Props> = ({ currentStep }) => {
  const activeStep = STEP_MAP[currentStep]
  if (activeStep === null) return null

  return (
    <Stepper activeStep={activeStep} alternativeLabel>
      {STEP_LABELS.map((label) => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

export default LeadActionPanelStepper
